<template>
  <div class="p-1 pt-3">
    <div v-if="allowDelete" class="mb-2 flex w-full items-center justify-end">
      <button
        class="rounded-full p-1 transition hover:bg-gray-300"
        @click="$emit('delete')"
      >
        <i-heroicons-minus-circle class="h-5 w-5" />
      </button>
    </div>
    <div class="relative flex flex-col gap-5 md:flex-row md:gap-2">
      <LinkCombobox v-model="selectedParagraph" :legalText="legalText" />
      <LexmeaInput
        :modelValue="model.additional_text"
        :label="t('additional_text')"
        :required="false"
        maxlength="30"
        @update:modelValue="handleUpdate('additional_text', $event)"
      />
    </div>
    <div class="mt-5">
      <LexmeaSelect
        :modelValue="model.link_type_id"
        :label="t('type_of_reference')"
        :required="false"
        :options="linkTypes"
        @update:modelValue="handleUpdate('link_type_id', $event)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ISelect } from "~/models/ISelect";
import type { ILegalText } from "~/models/ILegalText";
import type { ILink, INewLink } from "~/models/IUserEntry";
import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";

const props = defineProps<{
  linkTypes: ISelect[];
  legalText: ILegalText;
  paragraph: ILegalTextParagraph;
  modelValue: INewLink;
  allowDelete: boolean;
}>();
// TODO: Chris: Translate linkTypes in Backend

const emit = defineEmits<{
  "update:modelValue": [link: ILink];
  delete: [];
}>();

const legalText = toRef(props, "legalText");

const model = useVModel(props, "modelValue", emit);

const { t } = useI18n({ useScope: "local" });

const handleUpdate = (key: string, value: any) => {
  model.value = {
    ...model.value,
    [key]: value,
  };
};

const selectedParagraph = ref(model.value.legal_text_paragraph_linked);

watch(selectedParagraph, (paragraph) => {
  if (!paragraph) {
    model.value = {
      ...model.value,
      legal_text_paragraph_linked: undefined,
      legal_text_paragraph_linked_id: undefined,
      legal_text_paragraph: undefined,
    };
  } else {
    model.value = {
      ...model.value,
      legal_text_paragraph_linked: {
        ...paragraph,
        legal_text: paragraph.legal_text,
      },
      legal_text_paragraph_linked_id: paragraph.id,
      legal_text_paragraph: {
        ...props.paragraph,
        legal_text: legalText.value,
      },
    };
  }
});
</script>

<i18n>
{
  "de": {
    "additional_text": "Abs. / S. / Nr. / Var (optional)",
    "type_of_reference": "Art des Verweises (optional)"
  },
  "en": {
    "additional_text": "Para. / Page / No. / Var (optional)",
    "type_of_reference": "Type of reference (optional)"
  }
}
</i18n>
